export default {
  categoryInfo: {
    mainTitle: 'Cep Telefonu Sigortası',
    description: {
      title: 'Cep Telefonu Sigortası Nedir?',
      content: [
        'Doğum teminatı olarak sağlık sigortası poliçelerine eklenmektedir. Hamilelikle ilgili tüm masrafları kapsayan planları değerlendirerek poliçenize ekleyebileceğiniz bir ek teminattır.',
        'Cep telefonu sigortası ile koruma altına aldığınız telefonlarınız ister kırılsın isterse arızalansın tüm masraflarınız sigortanızdan karşılayabilirsiniz. Bu doğrultuda önemli olan telefon sigortası kapsamına alınan teminatlardır.'
      ]
    },
    subContent: {
      title: 'Cep Telefonu Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Çoğu insan telefonu olmadan evden asla çıkmaz, ancak çok azımız cep telefonu sigortası ile hasar veya kayıp için yeterince hazırlıklı olup olmadığımızı düşünüyoruz.',
          subList: null
        },
        {
          paragraph:
            'Cep telefonu sigortası telefonunuzun başına gelebilecek tüm risklere karşı güvence sağlayabilir. Sigortanız ile telefonunuzun karşılaşabileceği zararlar kapsamındaki masraflardan kurtulmuş olursunuz.',
          subList: null
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Cep Telefonu Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Cep telefonu sigortası, esasen bir garantinin içermediği her şeyi kapsar. Sigortalı telefonu olan kişiler, büyük miktarda para harcamaktan tek bir aksilik olmadıklarını bilerek rahat edebilirler.',
          subList: null
        },
        {
          paragraph:
            'Cep telefonu sigortası kapsamı sigorta şirketleri arasında farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph: 'Telefonunuz cep telefonu sigortası ile',
          subList: [
            'Kaza Sonucu Hasar Görme.',
            'Ekran Kırılması.',
            'Yüksek Voltaj İle Hasar Görme.',
            'Sıvı Teması.',
            'Hatalı Aksesuar Kullanımı sonucunda oluşan masraflar karşılanır.'
          ]
        },
        {
          paragraph:
            'Cep telefonu sigortası yaptırarak aksiliklere karşı oluşabilecek masrafları güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigortası Hakkında Bilinmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Hazırlıklı olmak daha iyi olsa da, sigortalı bir kişinin buna hiç ihtiyaç duymama şansı her zaman vardır. ',
          subList: null
        },
        {
          paragraph:
            'Cep telefonu sigortası, riskli ortamlarda çalışan, küçük çocukları olan veya genel olarak kazaya eğilimli kişiler için idealdir.',
          subList: null
        },
        {
          paragraph:
            'Telefonların kendisi de giderek daha az kırılgan hale geliyor, birçok yeni model artık suya dayanıklı. Bu durumları göz önünde bulundurarak diğer teminatları karşılaştırmalı ve gereksinimlerinizi belirleyerek satın almalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigortanın Cep Telefonu Garantisinden Farkı Nedir?',
      content: [
        {
          paragraph:
            'Garanti sadece sistemsel hatalı veya hasarlar sonucunda onarım sağlarken, cep telefonu sigortası ile sistemsel hasar veya sigortalıdan kaynaklı hasarları teminat altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonum Çalınırsa Ne Olur?',
      content: [
        {
          paragraph:
            'Cep telefonunuzun çalınması durumunda eş değer cihaz temini veya poliçede belirlenmiş olan muafiyet kesintisi sonucunda nakit ödeme yapılabilir.',
          subList: null
        },
        {
          paragraph:
            'Bu teminat sadece cihazın ikametgâh, iş yeri veya kilitli konumda araç içinden zorlama yolu ile aşırılmasını ifade eder. ',
          subList: null
        }
      ]
    },
    {
      title: 'Cihaz Onarımı Mümkün Olmadığında Ne Olur?',
      content: [
        {
          paragraph:
            'Yetkili servis tarafından onarım mümkün olmadığı kararlaştırılırsa, poliçedeki muafiyet bedelinin ödenmesi koşuluyla aynı marka ve model cihaz sigortalıya teslim edilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigortası Yapan Şirketler Hangileri?',
      content: [
        {
          paragraph:
            'Cep telefonu sigortasının ürünü tüm sigorta şirketlerinde bulunmasa da alokasko.com alarak siz sigortalılarımızın tüm ihtiyaçlarında yanında olabilmek için HDI Sigortadan cep telefonu sigortası ürününü sunabilmekteyiz.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigorta Planı Nasıl Seçilir?',
      content: [
        {
          paragraph:
            'Cep telefonu sigortası planları, telefonunuza zarar verirseniz masrafları karşılamanıza yardımcı olur. ',
          subList: null
        },
        {
          paragraph:
            'Birçok cep telefonu üreticisi ve kablosuz iletişim operatörü şirket içi garantiler veya koruma planları sunar. Üçüncü şahıs hizmet sağlayıcılarından gelen garantiler de acil veya beklenmedik bir maliyet durumunda kendinizi karşılamak için uygun seçeneklerdir. Bu planlar ucuz değil, bu yüzden maliyete değer mi?',
          subList: null
        },
        {
          paragraph:
            'Bu durumda karşılaştırmanız gereken en önemli adımların başında sigortanın ve garantinin sunduğu güvenceler olmalıdır. Telefonunuza gelen zararlar sonucunda “keşke sigortam olsaydı” dememek için cep telefonu sigortasına şans vermelisiniz!',
          subList: null
        },
        {
          paragraph:
            'En iyi planı seçmek için poliçe teminatlarını ve kapsamı karşılaştırmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigortası Planı Seçerken Nelere Dikkat Etmelisiniz?',
      content: [
        {
          paragraph:
            'Bir cep telefonu planı seçerken dikkate alınması gereken birkaç nokta vardır:',
          subList: [
            '<strong><em><u>Planın maliyeti bütçenize uyacak mı?</u></em></strong> Cep telefonu sigortası bütçenizi aşıyorsa, aylık taksitlere bölmeniz akıllıca olabilir. ',
            '<strong><em><u>Plan neyi kapsıyor?</u></em></strong> Örneğin, telefonunuzu düşürme eğilimindeyseniz, ekran değişimini kapsadığından emin olun.',
            '<strong><em><u>Onarımlar nasıl tamamlanır?</u></em></strong> Cep telefonunuzu başka bir yere göndermek zorunda mısınız, yani onarımlar tamamlanana kadar cep telefonsuz kalabilir misiniz?',
            '<strong><em><u>Plan için uygun musunuz?</u></em></strong> Sunulan sigortanın şartlarını incelemelisiniz, istediğiniz zaman sigorta kapsamını satın alabiliyor musunuz? ',
            '<strong><em><u>Plan şartları nelerdir?</u></em></strong> Bazı planlar çok büyük kesintiler gerektirir. Diğerleri hırsızlık gibi belirli olayları kapsamaz veya telefonunuzu tamamen değiştiremez, yalnızca onarır.'
          ]
        }
      ]
    },
    {
      title: 'Telefon Sigortasına Gerçekten İhtiyacım Var Mı?',
      content: [
        {
          paragraph:
            'Bir telefon sigortası satın almanıza gerek olmadığını düşünebilirsiniz, ancak cep telefonlarının yüksek maliyetini düşündüğünüzde, faydalı olabilir. ',
          subList: null
        },
        {
          paragraph:
            'Telefonunuzun başına gelecek zarar, kırılma veya çalınma durumuna karşı daha fazla bütçe ayırmanız gerekir. Bunun yerine cep telefonu sigortası yardımınıza yetişebilir.',
          subList: null
        },
        {
          paragraph:
            'Sigortanın iyi bir yatırım olup olmadığını anlamak için cep telefonu sigortası ile ilgili zarar matematiği yapmak sizin için önemlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Cep telefonunu sigortası yaptırmak telefonunuzun bozulmasından daha kolay.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden dolduracağınız başvuru formu ile cep telefonu sigortası hakkında daha detaylı bilgi ve teklif alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Telefonunuza özel sunacağımız fiyatı değerlendirebilir ve telefonunuzu güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Cep Telefonu Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Cep telefonu sigortası fiyatları cep telefonunun marka model bilgilerini göre değişiklik göstermektedir. ',
          subList: null
        },
        {
          paragraph:
            'Sizde telefonunuzun sigorta fiyatını merak ediyorsanız <a href="tel://02163716777">(0216) 371 67 77</a> numaralı hattan veya başvuru formu ile bizimle iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
